import * as _ from 'lodash';

const DEBOUNCE_DELAY = 250;

/*
  A simple helper that encapsulated searchable options for the react-select.
  */
export class SearchableModelHelper {
  onStateChange;
  getItem;
  findItems;
  options;
  oldValue;
  oldSearch;
  value;
  isLoading;
  isFailed;

  constructor(onStateChange, getItem, findItems) {
    this.onStateChange = onStateChange;
    this.getItem = getItem;
    this.findItems = findItems;

    this.search = _.debounce(this.search, DEBOUNCE_DELAY);

    this.options = [];
    this.oldValue = null;
    this.oldSearch = undefined;
    this.value = null;
    this.isLoading = 0;

    this.search(null);
  }

  getSelectValue = (value: any) => {
    // If we have a cached value - grab it
    if (this.value && this.value.value === value) {
      return this.value;
    }

    // If we have options - find it in the options
    if (this.options) {
      const option = this.options.find((opt) => opt.value === value);
      if (option) {
        this.value = option;
        return this.value;
      }
    }

    // Otherwise request it from the server
    if (value && value !== this.oldValue) {
      this.oldValue = value;

      this.getItem(value).then((opt) => {
        this.value = opt;
      })
      .finally(() => {
        this.isLoading -= 1;
        this.onStateChange();
      });

      this.isLoading += 1;
      this.onStateChange();
    }

    return null;
  }

  search = (needle: string = null) => {
    if (this.oldSearch === needle) {
      return;
    }

    this.oldSearch = needle;

    this.findItems(needle).then((options) => {
      this.options = options;
    }).finally(() => {
      this.isLoading -= 1;
      this.onStateChange();
    });

    this.isLoading += 1;
    this.onStateChange();
  }
}
